import { createSelector } from "@reduxjs/toolkit";
import type { RootState } from "../../../services/redux/types";

export const selectEmbeddingsState = (state: RootState) => state.embeddingsState;

export const selectModels = createSelector(
  selectEmbeddingsState,
  (state) => state.models,
);

export const selectSelectedModel = createSelector(
  selectEmbeddingsState,
  (state) => state.selectedModel
);

export const selectVectors = createSelector(
  selectEmbeddingsState,
  (state) => state.vectors
);

export const selectInputValues = createSelector(
  selectEmbeddingsState,
  (state) => state.inputValues
);

export const selectCoordinates = createSelector(
  selectEmbeddingsState,
  (state) => state.coordinates
);

export const selectLoading = createSelector(
  selectEmbeddingsState,
  (state) => state.isLoading
);

export const selectDisabled = createSelector(
  selectEmbeddingsState,
  (state) => state.isDisabled
);